import { BarChart3, CalendarDays, Wallet } from 'lucide-react';

/** The icon a data guide's card shows, by its category. */
export const CATEGORY_ICONS = { Research: BarChart3, 'Pay over time': Wallet, 'Booking tips': CalendarDays };
